import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports
import { Icon } from '../Icon';

export const Button = memo(
  ({
    children,
    className,
    to,
    variant = 'default',
    icon,
    loading,
    ...props
  }) => {
    const classButton = classNames(
      ' text-sm py-2 px-8 rounded transition duration-300 shadow',
      {
        'border border-cyan-600 text-cyan-700 hover:bg-cyan-600 hover:text-white':
          variant === 'default',
        'bg-cyan-600 text-white hover:bg-cyan-700': variant === 'primary',
        [className]: !!className,
      },
    );
    return (
      <button className={classButton} type="button" {...props}>
        {loading ? (
          <Icon name="spinner" className="fa-spin" />
        ) : (
          <>
            {icon && <Icon className="mr-2" name={icon} />}
            {to ? <Link to={to}>{children}</Link> : children}
          </>
        )}
      </button>
    );
  },
);

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  loading: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'primary']),
};
